import { useState } from "react";
import "./Contact.css";

const Contact = () => {

  const [lang, setLang] = useState("en");

  return (
    <div className="contact-wrapper">

      <div className="contact-box">

        {/* Language Switch */}
        <div style={{ textAlign: "right" }}>
          <button onClick={() => setLang("en")} className="lang-btn">English</button>
          <button onClick={() => setLang("hi")} className="lang-btn">हिंदी</button>
        </div>

        {/* ENGLISH */}
        {lang === "en" && (
          <>
            <h1 className="title">Contact Support</h1>
            <p className="sub">
              Our team is always ready to help you 😊
            </p>
          </>
        )}

        {/* HINDI */}
        {lang === "hi" && (
          <>
            <h1 className="title">सपोर्ट से संपर्क करें</h1>
            <p className="sub">
              हमारी टीम हमेशा आपकी सहायता के लिए तैयार है 😊
            </p>
          </>
        )}

        {/* Info Section */}
        <div className="contact-info">

          <div className="info-card">
            📞
            <h3>{lang === "en" ? "Call Support" : "कॉल सपोर्ट"}</h3>
            <p>+91 7303554199</p>
          </div>

          <div className="info-card">
            💬
            <h3>{lang === "en" ? "WhatsApp" : "व्हाट्सएप सपोर्ट"}</h3>
            <p>{lang === "en" ? "Instant Support Available" : "तुरंत सहायता उपलब्ध"}</p>
          </div>

          <div className="info-card">
            📍
            <h3>{lang === "en" ? "Office" : "ऑफिस"}</h3>
            <p>India</p>
          </div>

        </div>

        {/* Buttons */}
        <div className="contact-buttons">

          <a href="/" className="btn house">
            🏠 {lang === "en" ? "House" : "होम"}
          </a>

          <a href="/login" className="btn login">
            🔐 {lang === "en" ? "Login" : "लॉगिन"}
          </a>

          <a href="tel:7303554199" className="btn call">
            📞 {lang === "en" ? "Call Now" : "अभी कॉल करें"}
          </a>

          <a
            href="https://wa.me/917303554199?text=Hello%20Admin,%20I%20need%20support."
            className="btn whatsapp"
            target="_blank"
          >
            💬 {lang === "en" ? "WhatsApp Chat" : "व्हाट्सएप पर चैट करें"}
          </a>

        </div>

      </div>

    </div>
  );
};

export default Contact;
